(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[153],{

/***/ "E8Xq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return capitalizeFromUppercase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return capitalizeWordFirstCaracter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return capitalize; });
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("M+/F");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("Ysgh");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lodash_upperFirst__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("TYRa");
/* harmony import */ var lodash_upperFirst__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash_upperFirst__WEBPACK_IMPORTED_MODULE_5__);







function capitalize(string) {
  if (!string) {
    return '';
  }

  return string[0].toUpperCase() + string.slice(1);
}

var capitalizeFromUppercase = function capitalizeFromUppercase(str) {
  return lodash_upperFirst__WEBPACK_IMPORTED_MODULE_5___default()(str.toLowerCase());
};
var capitalizeWordFirstCaracter = function capitalizeWordFirstCaracter(str) {
  return str === null || str === void 0 ? void 0 : str.toLowerCase().split(' ').map(function (w) {
    return lodash_upperFirst__WEBPACK_IMPORTED_MODULE_5___default()(w);
  }).join(' ');
};


/***/ }),

/***/ "HAu2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useRouterEvents; });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("Bkb1");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);


function useRouterEvents() {
  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_1__["useState"])(false),
      transitioning = _useState[0],
      setTransitioning = _useState[1];

  var router = Object(next_router__WEBPACK_IMPORTED_MODULE_0__["useRouter"])();
  Object(react__WEBPACK_IMPORTED_MODULE_1__["useEffect"])(function () {
    var routeChangeStartHandler = function routeChangeStartHandler() {
      setTransitioning(true);
    };

    var routeChangeCompleteHandler = function routeChangeCompleteHandler() {
      setTransitioning(false);
    };

    router.events.on('routeChangeStart', routeChangeStartHandler);
    router.events.on('routeChangeComplete', routeChangeCompleteHandler);
    return function () {
      router.events.off('routeChangeStart', routeChangeStartHandler);
      router.events.off('routeChangeComplete', routeChangeCompleteHandler);
    };
  }, []);
  return {
    transitioning: transitioning
  };
}

/***/ }),

/***/ "bpGR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./src/client/components/lines/prebooking-form-line/PrebookingFormLine.utils.js
var PrebookingFormLine_utils = __webpack_require__("chol");

// EXTERNAL MODULE: ./src/client/components/widgets/product-quotation-form/productQuotationForm.constants.js
var productQuotationForm_constants = __webpack_require__("Dcno");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/store/utils/selectOptionsBuilders.js
var selectOptionsBuilders = __webpack_require__("7F8I");

// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// EXTERNAL MODULE: /opt/webapp/node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__("3yYM");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("QsI/");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("VtSi");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: /opt/webapp/node_modules/formik/dist/formik.esm.js + 76 modules
var formik_esm = __webpack_require__("ljKo");

// EXTERNAL MODULE: /opt/webapp/node_modules/next/router.js
var next_router = __webpack_require__("Bkb1");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__("lTEL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("KOtZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("6U7i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.number.is-nan.js
var es_number_is_nan = __webpack_require__("ssvU");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__("kYxP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/omit.js
var omit = __webpack_require__("uZih");
var omit_default = /*#__PURE__*/__webpack_require__.n(omit);

// EXTERNAL MODULE: /opt/webapp/node_modules/yup/lib/index.js
var lib = __webpack_require__("luEP");

// EXTERNAL MODULE: /opt/webapp/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: ./src/utils/graphql/index.js
var graphql = __webpack_require__("NLwV");

// EXTERNAL MODULE: ./src/utils/graphql-client/graphqlClient.js
var graphqlClient = __webpack_require__("PIvV");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// EXTERNAL MODULE: ./src/utils/string/stringUtils.js
var stringUtils = __webpack_require__("E8Xq");

// EXTERNAL MODULE: ./src/client/components/utils/common-validator/CommonValidators.js
var CommonValidators = __webpack_require__("cjjV");

// CONCATENATED MODULE: ./src/client/components/widgets/product-quotation-form/productQuotationForm.utils.js





















function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}










 // Initialize form values

var productQuotationForm_utils_getInitialFormValues = function getInitialFormValues(_ref) {
  var departureCityDisabled = _ref.departureCityDisabled,
      extensionOptions = _ref.extensionOptions,
      isProductWithSetDates = _ref.isProductWithSetDates,
      isSummerCamp = _ref.isSummerCamp,
      traveler = _ref.traveler;
  return _objectSpread(_objectSpread(_objectSpread({
    adultsNumber: isSummerCamp ? productQuotationForm_constants["f" /* MIN_FORM_TEENS */].toString() : productQuotationForm_constants["d" /* MIN_FORM_ADULTS */].toString(),
    comment: '',
    departureCity: departureCityDisabled ? productQuotationForm_constants["g" /* NO_VALUE */] : '',
    departureDate: !isProductWithSetDates ? {
      from: null,
      to: null
    } : ''
  }, extensionOptions.length > 0 ? {
    extension: ''
  } : null), isSummerCamp ? null : {
    kidsNumber: productQuotationForm_constants["e" /* MIN_FORM_KIDS */].toString()
  }), {}, {
    optinEmail: false,
    traveler: traveler
  });
}; // Set form schema

var productQuotationForm_utils_getFormSchema = function getFormSchema(t, _ref2) {
  var agencies = _ref2.agencies,
      civilityOptions = _ref2.civilityOptions,
      departureCityOptions = _ref2.departureCityOptions,
      departureDateOptions = _ref2.departureDateOptions,
      extensionOptions = _ref2.extensionOptions,
      isProductWithSetDates = _ref2.isProductWithSetDates,
      isSummerCamp = _ref2.isSummerCamp;
  var agencySchema = lib["mixed"]().oneOf(agencies.map(function (_ref3) {
    var value = _ref3.value;
    return value;
  })).required();
  var fistNameSchema = lib["string"]().required(t('productQuotationForm.coordinates.firstName')).max(20, t('productQuotationForm.coordinates.firstName'));
  var lastNameSchema = lib["string"]().required(t('productQuotationForm.coordinates.lastName')).max(30, t('productQuotationForm.coordinates.lastName'));
  return lib["object"]().shape(_objectSpread(_objectSpread(_objectSpread({
    adultsNumber: lib["string"]().required(),
    comment: lib["string"](),
    departureCity: lib["mixed"]().oneOf(departureCityOptions.map(function (c) {
      return c.value;
    })).required(),
    departureDate: !isProductWithSetDates ? lib["object"]().shape({
      from: lib["date"](),
      to: lib["date"]().nullable()
    }).required() : lib["mixed"]().oneOf(departureDateOptions.map(function (d) {
      return d.value;
    })).required()
  }, extensionOptions.length > 0 ? {
    extension: lib["mixed"]().oneOf(extensionOptions.map(function (e) {
      return e.value;
    })).required()
  } : null), isSummerCamp ? null : {
    kidsNumber: lib["string"]().required()
  }), {}, {
    optinEmail: lib["boolean"](),
    traveler: lib["object"]().shape(_objectSpread(_objectSpread({}, agencies.length ? {
      agency: agencySchema
    } : null), {}, {
      civility: lib["mixed"]().oneOf(civilityOptions.map(function (c) {
        return c.value;
      })).required(),
      email: lib["string"]().email(t('productQuotationForm.coordinates.email')).required(t('productQuotationForm.coordinates.email')),
      gmNumber: lib["string"]().matches(CommonValidators["a" /* GM_NUMBER_PATTERN */]),
      firstName: fistNameSchema,
      lastName: lastNameSchema,
      phone: lib["string"]().required(t('productQuotationForm.coordinates.phoneNumber')).matches(/^(\+[1-9]|0)?\d{1,14}$/, {
        excludeEmptyString: true,
        message: t('productQuotationForm.coordinates.phoneNumber')
      })
    }))
  }));
}; // Submit form

var FORM_STATUS = {
  NEW: 'new',
  SUCCESS: 'success',
  ERROR: 'error'
};

var productQuotationForm_utils_getFormattedDepartureDate = function getFormattedDepartureDate(date) {
  return typeof date === 'string' ? date : Object(apiDate["m" /* momentToApiDate */])(moment_default()(date.from || Date.now()));
};

var KIDS_ATTENDEES_TYPE = 'CHILDREN';

var getAttendeesQuery = function getAttendeesQuery(attendees, type) {
  return attendees.reduce(function (acc, attendee) {
    return "".concat(acc).concat(getAttendeeQuery(attendee, type));
  }, '');
};

var productQuotationForm_utils_formatDate = function formatDate(date) {
  return Object(apiDate["m" /* momentToApiDate */])(moment_default()(date));
};

var getAttendeeQuery = function getAttendeeQuery(attendee, type) {
  var birthdate = attendee.birthdate;
  return "{\n    birthdate: \"".concat(birthdate ? productQuotationForm_utils_formatDate(birthdate) : '', "\"\n    type: \"").concat(type, "\"\n  }");
};

var productQuotationForm_utils_getProductQuotationFormMutation = function getProductQuotationFormMutation(values, product) {
  var adultsNumber = values.adultsNumber,
      _values$kids = values.kids,
      kids = _values$kids === void 0 ? [] : _values$kids,
      _values$kidsNumber = values.kidsNumber,
      kidsNumber = _values$kidsNumber === void 0 ? 0 : _values$kidsNumber,
      comment = values.comment,
      departureCity = values.departureCity,
      departureDate = values.departureDate,
      _values$extension = values.extension,
      extension = _values$extension === void 0 ? '' : _values$extension,
      optinEmail = values.optinEmail,
      traveler = values.traveler;
  var productId = product.productId,
      productLabel = product.productLabel,
      productRangeLabel = product.productRangeLabel;
  var civility = traveler.civility,
      email = traveler.email,
      firstName = traveler.firstName,
      lastName = traveler.lastName,
      phone = traveler.phone,
      agency = traveler.agency,
      _traveler$gmNumber = traveler.gmNumber,
      gmNumber = _traveler$gmNumber === void 0 ? '' : _traveler$gmNumber;
  var formattedDepartureDate = productQuotationForm_utils_getFormattedDepartureDate(departureDate);
  return "mutation {\n    productRequest(\n      adultsCount: ".concat(parseInt(adultsNumber, 10), "\n      attendeesBirthdates: [").concat(getAttendeesQuery(kids, KIDS_ATTENDEES_TYPE), "]\n      childrenCount: ").concat(parseInt(kidsNumber, 10), "\n      contact: {\n        civility: \"").concat(civility, "\"\n        firstName: \"").concat(firstName, "\"\n        lastName: \"").concat(lastName, "\"\n        email: \"").concat(email, "\"\n        mobile: \"").concat(phone, "\"\n        agency: \"").concat(agency, "\"\n        gmNumber: \"").concat(gmNumber, "\"\n      }\n      customerComment: ").concat(Object(graphql["e" /* graphqlifyString */])(comment), "\n      departureCity: \"").concat(departureCity || productQuotationForm_constants["g" /* NO_VALUE */], "\"\n      departureDate: \"").concat(formattedDepartureDate, "\"\n      extensionName: \"").concat(extension, "\"\n      productId: \"").concat(productId, "\"\n      productLabel: \"").concat(productLabel, "\"\n      productRangeLabel: \"").concat(productRangeLabel || Object(stringUtils["b" /* capitalizeFromUppercase */])(product.type), "\"\n      optinEmail: ").concat(optinEmail.toString(), "\n    ) {\n      statusCode\n    }\n  }");
};
var getNewsletterSubscriptionMutation = function getNewsletterSubscriptionMutation(values, newsletterId) {
  var _values$traveler = values.traveler,
      civility = _values$traveler.civility,
      email = _values$traveler.email,
      firstName = _values$traveler.firstName,
      lastName = _values$traveler.lastName;
  return "mutation {\n    subscription (\n      civility: \"".concat(civility, "\"\n      email: \"").concat(email, "\"\n      firstName: \"").concat(firstName, "\"\n      isSubscription: true\n      lastName: \"").concat(lastName, "\"\n      newsletterSubscriptions : [\"").concat(newsletterId, "\"]\n      unicodeFirstName: \"").concat(firstName, "\"\n      unicodeLastName: \"").concat(lastName, "\"\n    ) {\n      id\n      neolaneId\n    }\n  }");
};
var handleSubmit = /*#__PURE__*/function () {
  var _ref4 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(values, params) {
    var actions, appContext, product, quotation, redirectUris, productQuotationFormMutation, _yield$graphQLClient$, productRequest, router, queryParams, hasNoTransport, url;

    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            actions = params.actions, appContext = params.appContext, product = params.product, quotation = params.quotation, redirectUris = params.redirectUris;
            actions.setSubmitting(true);
            productQuotationFormMutation = productQuotationForm_utils_getProductQuotationFormMutation(values, product);
            _context.prev = 3;
            _context.next = 6;
            return graphqlClient["a" /* default */].runNoCacheQuery(productQuotationFormMutation, appContext, {
              requestName: requestDictionary["qd" /* WIDGET_QUOTATION_FORM_SUBMIT */]
            });

          case 6:
            _yield$graphQLClient$ = _context.sent;
            productRequest = _yield$graphQLClient$.productRequest;

            if (productRequest.statusCode === 500) {
              actions.setStatus(_objectSpread({
                state: FORM_STATUS.ERROR
              }, quotation.error));
            } else {
              router = params.router;
              queryParams = omit_default()(router.query, ['dynamicPage']);
              hasNoTransport = values.departureCity === '' || values.departureCity === 'NO';
              url = new URI_default.a(redirectUris.success).query(_objectSpread(_objectSpread({}, queryParams), {}, {
                productId: params.product.productId,
                departureDate: productQuotationForm_utils_getFormattedDepartureDate(values.departureDate),
                adults: parseInt(values.adultsNumber, 10),
                children: parseInt(values.kidsNumber, 10),
                transport: hasNoTransport ? 'without transport' : values.departureCity
              })).toString();
              router.push(url);
            }

            _context.next = 15;
            break;

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](3);
            console.log(_context.t0);
            actions.setStatus(_objectSpread({
              state: FORM_STATUS.ERROR
            }, quotation.error));

          case 15:
            _context.prev = 15;
            actions.setSubmitting(false);
            return _context.finish(15);

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 11, 15, 18]]);
  }));

  return function handleSubmit(_x, _x2) {
    return _ref4.apply(this, arguments);
  };
}();
var getFormUser = function getFormUser(user) {
  var _user$civility = user.civility,
      civility = _user$civility === void 0 ? '' : _user$civility,
      _user$email = user.email,
      email = _user$email === void 0 ? '' : _user$email,
      _user$firstName = user.firstName,
      firstName = _user$firstName === void 0 ? '' : _user$firstName,
      _user$GMNumber = user.GMNumber,
      GMNumber = _user$GMNumber === void 0 ? '' : _user$GMNumber,
      _user$lastName = user.lastName,
      lastName = _user$lastName === void 0 ? '' : _user$lastName,
      _user$mobilePhoneNumb = user.mobilePhoneNumber,
      mobilePhoneNumber = _user$mobilePhoneNumb === void 0 ? '' : _user$mobilePhoneNumb,
      _user$isProspect = user.isProspect,
      isProspect = _user$isProspect === void 0 ? false : _user$isProspect;
  return _objectSpread(_objectSpread({
    civility: civility,
    email: email,
    firstName: firstName
  }, !isProspect ? {
    gmNumber: GMNumber
  } : {}), {}, {
    lastName: lastName,
    phone: mobilePhoneNumber
  });
};
var productQuotationForm_utils_getKidFutureBithdateValidator = function getKidFutureBithdateValidator(minAuthorizedAgeInMonths, maxAuthorizedAgeInMonths) {
  return lib["number"]().transform(function (value) {
    return Number.isNaN(value) ? undefined : value;
  }).test('isOldEnough', function (value) {
    //errorMessage, function (value: number) {
    var context = this.options.context;

    if (value && (context === null || context === void 0 ? void 0 : context.values.departureDate)) {
      var departureDate = moment_default()(context === null || context === void 0 ? void 0 : context.values.departureDate).startOf('day');
      var kidBirthdate = moment_default()(value).startOf('day');
      var validBirthdate = kidBirthdate.isBefore(departureDate);

      if (minAuthorizedAgeInMonths && maxAuthorizedAgeInMonths) {
        var ageInMonths = departureDate.diff(kidBirthdate, 'months');
        console.log(ageInMonths);
        return validBirthdate && ageInMonths >= minAuthorizedAgeInMonths && ageInMonths <= maxAuthorizedAgeInMonths;
      }

      return validBirthdate;
    }

    return false;
  }).nullable().required();
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("jQ/y");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.fill.js
var es_array_fill = __webpack_require__("i4UL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("M+/F");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/router/useRouterEvents.js
var useRouterEvents = __webpack_require__("HAu2");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/frameworks/formik/FormikInput.jsx + 13 modules
var FormikInput = __webpack_require__("/HC4");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx
var Text = __webpack_require__("qqKu");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/utils/feature-flipping/featureFlippingUtils.js
var featureFlippingUtils = __webpack_require__("L7OA");

// EXTERNAL MODULE: ./src/client/components/widgets/confirmation/Confirmation.jsx
var Confirmation = __webpack_require__("Fmrk");

// CONCATENATED MODULE: ./src/client/components/widgets/product-quotation-form/ProductQuotationFormKidBirthdate.jsx
var __jsx = react_default.a.createElement;




var ProductQuotationFormKidBirthdate_ProductQuotationFormKidBirthdate = function ProductQuotationFormKidBirthdate(_ref) {
  var dateFormat = _ref.dateFormat,
      index = _ref.index,
      kidsNumber = _ref.kidsNumber,
      minAuthorizedAgeInMonths = _ref.minAuthorizedAgeInMonths,
      maxAuthorizedAgeInMonths = _ref.maxAuthorizedAgeInMonths;
  return __jsx("div", {
    className: "".concat(kidsNumber > 1 ? 'w-1/2' : 'w-full', " p-10")
  }, __jsx("p", {
    className: "mb-10 text-14 font-bold"
  }, Object(i18n["h" /* t */])('productQuotationForm.pax.kidLabel', {
    n: index + 1
  })), __jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "kids-".concat(index, "-birthdate-field"),
    hideErrorMessage: true,
    name: "kids.".concat(index, ".birthdate"),
    type: "birthdate",
    dayPlaceholder: "DD",
    monthPlaceholder: "MM",
    yearPlaceholder: "YYYY",
    dateFormat: dateFormat,
    validate: productQuotationForm_utils_getKidFutureBithdateValidator(minAuthorizedAgeInMonths, maxAuthorizedAgeInMonths)
  }));
};
// EXTERNAL MODULE: ./src/client/components/widgets/trip-information/participants/participants.constants.js
var participants_constants = __webpack_require__("93Yv");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTrackEvent.js
var useTrackEvent = __webpack_require__("DqI1");

// CONCATENATED MODULE: ./src/client/components/widgets/product-quotation-form/ProductQuotationForm.jsx



















var ProductQuotationForm_jsx = react_default.a.createElement;

function ProductQuotationForm_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ProductQuotationForm_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ProductQuotationForm_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ProductQuotationForm_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






















var DEFAULT_KID = {
  birthdate: null
};

var FormFieldNote = function FormFieldNote(_ref) {
  var note = _ref.note;
  return ProductQuotationForm_jsx("span", {
    className: "mt-5 text-12 text-mediumGrey"
  }, note);
};

function ProductQuotationForm(_ref2) {
  var adultsOptions = _ref2.adultsOptions,
      ageIndicationAdults = _ref2.ageIndicationAdults,
      ageIndicationKids = _ref2.ageIndicationKids,
      availableDatesIndication = _ref2.availableDatesIndication,
      agencies = _ref2.agencies,
      civilityOptions = _ref2.civilityOptions,
      dateFormat = _ref2.dateFormat,
      departureCityDisabled = _ref2.departureCityDisabled,
      departureCityOptions = _ref2.departureCityOptions,
      departureDateOptions = _ref2.departureDateOptions,
      departureDateEnd = _ref2.departureDateEnd,
      departureDateStart = _ref2.departureDateStart,
      extensionOptions = _ref2.extensionOptions,
      footnotes = _ref2.footnotes,
      hasUser = _ref2.hasUser,
      isProductWithSetDates = _ref2.isProductWithSetDates,
      isSummerCamp = _ref2.isSummerCamp,
      kidsOptions = _ref2.kidsOptions,
      newsletter = _ref2.newsletter,
      consentOptins = _ref2.consentOptins,
      product = _ref2.product;
  var isProspect = Object(es["e" /* useSelector */])(function (state) {
    var userInfo = state.userInfo;
    return userInfo === null || userInfo === void 0 ? void 0 : userInfo.isProspect;
  });

  var _useFormikContext = Object(formik_esm["e" /* useFormikContext */])(),
      isSubmitting = _useFormikContext.isSubmitting,
      isValid = _useFormikContext.isValid,
      resetForm = _useFormikContext.resetForm,
      setValues = _useFormikContext.setValues,
      status = _useFormikContext.status,
      values = _useFormikContext.values,
      initialValues = _useFormikContext.initialValues,
      setFieldValue = _useFormikContext.setFieldValue;

  var _useRouterEvents = Object(useRouterEvents["a" /* useRouterEvents */])(),
      transitioning = _useRouterEvents.transitioning;

  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var isQuotationCommentDisabled = Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('quotation.disableComment');

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var optinEmail = consentOptins.optinEmail,
      optinProfile = consentOptins.optinProfile;

  var _React$useState = react_default.a.useState(false),
      _React$useState2 = Object(slicedToArray["a" /* default */])(_React$useState, 2),
      isClient = _React$useState2[0],
      setIsClient = _React$useState2[1];

  Object(react["useEffect"])(function () {
    if (transitioning) {
      resetForm();
    }
  }, [transitioning]);
  Object(react["useEffect"])(function () {
    setIsClient(true);
  }, []);
  Object(react["useEffect"])(function () {
    if (agencies && agencies.length === 1) {
      setFieldValue('traveler.agency', agencies[0].value);
    }
  }, [agencies]);
  var hasLoggedUserNumber = isClient && hasUser && !!initialValues.traveler.gmNumber;
  var isProspectUser = isClient && hasUser && isProspect;
  var _values$kids = values.kids,
      kids = _values$kids === void 0 ? [] : _values$kids,
      _values$kidsNumber = values.kidsNumber,
      kidsNumber = _values$kidsNumber === void 0 ? '0' : _values$kidsNumber;
  var kidsInt = parseInt(kidsNumber, 10);

  var handleKidsNumber = function handleKidsNumber(e) {
    var updatedKidsNumber = e.target.value;
    var updatedKidsInt = parseInt(updatedKidsNumber, 10);
    var newKids = updatedKidsInt - kidsInt;
    var updatedKids = newKids > 0 ? [].concat(Object(toConsumableArray["a" /* default */])(kids), Object(toConsumableArray["a" /* default */])(Array(newKids).fill(null).map(function () {
      return DEFAULT_KID;
    }))) : kids.slice(0, updatedKidsInt);
    setValues(ProductQuotationForm_objectSpread(ProductQuotationForm_objectSpread({}, values), {}, {
      kidsNumber: updatedKidsNumber,
      kids: updatedKids
    }));
  };

  var defaultMinAuthorizedAge = product.rangeId === productQuotationForm_constants["j" /* RANGE_ESCAPADE */] ? participants_constants["a" /* DEFAULT_ESCAPADE_MIN_CHILD_AGE */] : participants_constants["e" /* DEFAULT_TOUR_MIN_CHILD_AGE */];
  var minAuthorizedAgeInMonths = product.minAuthorizedAge.value ? product.minAuthorizedAge.value : defaultMinAuthorizedAge;
  var maxAuthorizedAgeInMonths = participants_constants["c" /* DEFAULT_MAX_CHILD_AGE */] * 12;
  return ProductQuotationForm_jsx(formik_esm["c" /* Form */], {
    id: productQuotationForm_constants["h" /* QUOTATION_FORM_ID */],
    "data-testid": productQuotationForm_constants["h" /* QUOTATION_FORM_ID */]
  }, ProductQuotationForm_jsx(Title["a" /* Title */], {
    className: "mb-5 mt-30 px-10",
    hLevel: 3,
    theme: "title-sans-n4"
  }, Object(i18n["h" /* t */])('productQuotationForm.criteria.title')), ProductQuotationForm_jsx("div", {
    className: "flex flex-wrap"
  }, ProductQuotationForm_jsx("div", {
    className: "w-full p-10 md:w-1/2"
  }, !isProductWithSetDates ? ProductQuotationForm_jsx(FormikInput["a" /* FormikInput */], {
    className: "z-1",
    dataTestId: "departure-date-field",
    dateFormat: dateFormat,
    hideErrorMessage: true,
    isRequired: true,
    label: Object(i18n["h" /* t */])('productQuotationForm.criteria.dateLabel'),
    maxDate: departureDateEnd,
    minDate: departureDateStart,
    name: "departureDate",
    placeholder: Object(i18n["h" /* t */])('productQuotationForm.criteria.datePlaceholder'),
    type: "datepicker"
  }) : ProductQuotationForm_jsx(react["Fragment"], null, ProductQuotationForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "departure-date-field",
    hideErrorMessage: true,
    isDisabled: departureDateOptions.length === 0,
    isRequired: true,
    label: Object(i18n["h" /* t */])('productQuotationForm.criteria.dateLabel'),
    name: "departureDate",
    options: departureDateOptions,
    placeholder: Object(i18n["h" /* t */])('productQuotationForm.criteria.datePlaceholder'),
    type: "select"
  }), departureDateOptions.length === 0 && ProductQuotationForm_jsx("span", {
    className: "mt-5 flex items-center gap-5 text-12 text-black"
  }, ProductQuotationForm_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].WARNING,
    width: ".75rem"
  }), availableDatesIndication))), extensionOptions.length > 0 && ProductQuotationForm_jsx("div", {
    className: "w-full p-10 md:w-1/2"
  }, ProductQuotationForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "extension-field",
    hideErrorMessage: true,
    isRequired: true,
    label: Object(i18n["h" /* t */])('productQuotationForm.criteria.extensionLabel'),
    name: "extension",
    options: extensionOptions,
    placeholder: Object(i18n["h" /* t */])('productQuotationForm.criteria.extensionPlaceholder'),
    type: "select"
  })), ProductQuotationForm_jsx("div", {
    className: "w-full p-10 md:w-1/2"
  }, ProductQuotationForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "departure-city-field",
    hideErrorMessage: true,
    isDisabled: departureCityDisabled,
    isRequired: !departureCityDisabled,
    label: Object(i18n["h" /* t */])('productQuotationForm.criteria.transportationLabel'),
    name: "departureCity",
    options: departureCityOptions,
    placeholder: Object(i18n["h" /* t */])('productQuotationForm.criteria.transportationPlaceholder'),
    type: "select"
  }))), ProductQuotationForm_jsx(Title["a" /* Title */], {
    className: "mb-5 mt-30 px-10",
    hLevel: 3,
    theme: "title-sans-n4"
  }, Object(i18n["h" /* t */])('productQuotationForm.pax.title')), ProductQuotationForm_jsx("div", {
    className: "flex flex-wrap"
  }, ProductQuotationForm_jsx("p", {
    className: "mb-0 mt-10 w-full px-10 text-14 font-bold"
  }, Object(i18n["h" /* t */])('productQuotationForm.pax.paxLabel'), '*'), ProductQuotationForm_jsx("div", {
    className: "w-full p-10 md:w-1/2"
  }, ProductQuotationForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "adults-number-field",
    hideErrorMessage: true,
    name: "adultsNumber",
    options: adultsOptions,
    type: "select"
  }), ProductQuotationForm_jsx(FormFieldNote, {
    note: ageIndicationAdults
  })), !isSummerCamp && ProductQuotationForm_jsx("div", {
    className: "w-full p-10 md:w-1/2"
  }, ProductQuotationForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "kids-number-field",
    hideErrorMessage: true,
    name: "kidsNumber",
    onChange: handleKidsNumber,
    options: kidsOptions,
    type: "select"
  }), ProductQuotationForm_jsx(FormFieldNote, {
    note: ageIndicationKids
  })), kids.length > 0 && ProductQuotationForm_jsx(react["Fragment"], null, ProductQuotationForm_jsx("div", {
    className: "w-full p-10 pb-0"
  }, ProductQuotationForm_jsx("p", {
    className: "text-14 font-bold"
  }, Object(i18n["h" /* t */])('productQuotationForm.pax.kidsDatesOfBirthLabel'))), ProductQuotationForm_jsx("div", {
    className: "flex flex-wrap"
  }, kids.map(function (kid, index) {
    return ProductQuotationForm_jsx(ProductQuotationFormKidBirthdate_ProductQuotationFormKidBirthdate, {
      key: "kid-".concat(index),
      dateFormat: dateFormat,
      index: index,
      kidsNumber: kids.length,
      minAuthorizedAgeInMonths: minAuthorizedAgeInMonths,
      maxAuthorizedAgeInMonths: maxAuthorizedAgeInMonths
    });
  })))), ProductQuotationForm_jsx(Title["a" /* Title */], {
    className: "mb-5 mt-30 px-10",
    hLevel: 3,
    theme: "title-sans-n4"
  }, Object(i18n["h" /* t */])('productQuotationForm.coordinates.title')), ProductQuotationForm_jsx("div", {
    className: "flex flex-wrap"
  }, ProductQuotationForm_jsx("p", {
    className: "mb-0 mt-10 w-full px-10 text-14 font-bold"
  }, Object(i18n["h" /* t */])('productQuotationForm.coordinates.informationLabel')), ProductQuotationForm_jsx("div", {
    className: "w-full"
  }, ProductQuotationForm_jsx("div", {
    className: "w-full p-10 md:w-1/2"
  }, ProductQuotationForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "traveler-civility-field",
    hideErrorMessage: true,
    isRequired: true,
    name: "traveler.civility",
    options: civilityOptions,
    placeholder: "".concat(Object(i18n["h" /* t */])('productQuotationForm.coordinates.civility'), " *"),
    type: "select"
  }))), ProductQuotationForm_jsx("div", {
    className: "w-full p-10 md:w-1/2"
  }, ProductQuotationForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "traveler-firstName-field",
    hideErrorMessage: true,
    isRequired: true,
    name: "traveler.firstName",
    placeholder: "".concat(Object(i18n["h" /* t */])('productQuotationForm.coordinates.firstName'), " *"),
    type: "text"
  })), ProductQuotationForm_jsx("div", {
    className: "w-full p-10 md:w-1/2"
  }, ProductQuotationForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "traveler-lastName-field",
    hideErrorMessage: true,
    isRequired: true,
    name: "traveler.lastName",
    placeholder: "".concat(Object(i18n["h" /* t */])('productQuotationForm.coordinates.lastName'), " *"),
    type: "text"
  })), ProductQuotationForm_jsx("div", {
    className: "w-full p-10 md:w-1/2"
  }, ProductQuotationForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "traveler-email-field",
    hideErrorMessage: true,
    isRequired: true,
    name: "traveler.email",
    placeholder: "".concat(Object(i18n["h" /* t */])('productQuotationForm.coordinates.email'), " *"),
    type: "text"
  })), ProductQuotationForm_jsx("div", {
    className: "w-full p-10 md:w-1/2"
  }, ProductQuotationForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "traveler-phone-field",
    hideErrorMessage: true,
    isRequired: true,
    name: "traveler.phone",
    placeholder: "".concat(Object(i18n["h" /* t */])('productQuotationForm.coordinates.phoneNumber'), " *"),
    type: "text"
  })), ProductQuotationForm_jsx("div", {
    className: "w-full p-10 md:w-1/2"
  }, ProductQuotationForm_jsx("p", {
    className: "mb-5 mt-10 w-full px-10 text-14 font-bold"
  }, Object(i18n["h" /* t */])('productQuotationForm.coordinates.gmNumberLabel')), ProductQuotationForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "traveler-gm-number-field",
    hideErrorMessage: true,
    isDisabled: !isClient || hasLoggedUserNumber || isProspectUser,
    name: "traveler.gmNumber",
    placeholder: Object(i18n["h" /* t */])('productQuotationForm.coordinates.gmNumberPlaceholder'),
    type: "text"
  })), agencies.length > 1 && ProductQuotationForm_jsx("div", {
    className: "w-full p-10 md:w-1/2"
  }, ProductQuotationForm_jsx("p", {
    className: "mb-5 mt-10 w-full px-10 text-14 font-bold"
  }, Object(i18n["h" /* t */])('productQuotationForm.coordinates.favoriteTravelAgencyLabel')), ProductQuotationForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "traveler-agency-field",
    hideErrorMessage: true,
    isRequired: true,
    name: "traveler.agency",
    options: agencies,
    placeholder: "".concat(Object(i18n["h" /* t */])('productQuotationForm.coordinates.favoriteTravelAgencyPlaceholder'), " *"),
    type: "select"
  })), optinEmail && ProductQuotationForm_jsx("div", {
    className: "w-full p-10"
  }, ProductQuotationForm_jsx(FormikInput["a" /* FormikInput */], {
    className: "mb-10",
    dataTestId: "optin-email-field",
    label: newsletter.description || optinEmail.title,
    name: "optinEmail",
    optimized: true,
    type: "checkbox"
  }), (optinEmail === null || optinEmail === void 0 ? void 0 : optinEmail.description) && ProductQuotationForm_jsx(Text["a" /* Text */], {
    className: "mt-15",
    text: optinEmail.description,
    theme: "text-sans-n2"
  }), (optinProfile === null || optinProfile === void 0 ? void 0 : optinProfile.description) && ProductQuotationForm_jsx(Text["a" /* Text */], {
    className: "mt-15",
    text: optinProfile.description,
    theme: "text-sans-n2"
  }))), !isQuotationCommentDisabled && ProductQuotationForm_jsx(react["Fragment"], null, ProductQuotationForm_jsx(Title["a" /* Title */], {
    className: "mb-5 mt-30 px-10",
    hLevel: 3,
    theme: "title-sans-n4"
  }, Object(i18n["h" /* t */])('productQuotationForm.specialRequest.title')), ProductQuotationForm_jsx("div", {
    className: "w-full p-10"
  }, ProductQuotationForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "comment-field",
    name: "comment",
    placeholder: Object(i18n["h" /* t */])('productQuotationForm.specialRequest.placeholder'),
    type: "textarea"
  }))), ProductQuotationForm_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('mt-30 flex px-10', {
      'text-right': status.state === FORM_STATUS.NEW
    })
  }, status.state !== FORM_STATUS.NEW && ProductQuotationForm_jsx(Confirmation["a" /* Confirmation */], Object(esm_extends["a" /* default */])({}, status, {
    status: status.state
  })), ProductQuotationForm_jsx("div", {
    className: "flex-1 text-right"
  }, ProductQuotationForm_jsx(Button["a" /* Button */], {
    "data-testid": "product-quotation-submit",
    isDisabled: !isValid,
    isLoading: isSubmitting,
    onClick: function onClick() {
      trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_SHOPPING_TOUR_QUOTE, {
        detail_click: 'validate_quote'
      });
    },
    type: "submit"
  }, Object(i18n["h" /* t */])('productQuotationForm.quotation.buttonLabel')), footnotes.length > 0 && ProductQuotationForm_jsx("div", {
    className: "max-w-full py-10 text-14 leading-normal text-black"
  }, footnotes.map(function (note) {
    return ProductQuotationForm_jsx("p", {
      className: "my-0",
      key: note
    }, note);
  })))));
}
// CONCATENATED MODULE: ./src/client/components/widgets/product-quotation-form/ProductQuotationFormContainer.jsx


var ProductQuotationFormContainer_jsx = react_default.a.createElement;









function ProductQuotationFormContainer(_ref) {
  var adultsOptions = _ref.adultsOptions,
      ageIndicationAdults = _ref.ageIndicationAdults,
      ageIndicationKids = _ref.ageIndicationKids,
      availableDatesIndication = _ref.availableDatesIndication,
      agencies = _ref.agencies,
      civilityOptions = _ref.civilityOptions,
      dateFormat = _ref.dateFormat,
      departureCityDisabled = _ref.departureCityDisabled,
      departureCityOptions = _ref.departureCityOptions,
      departureDateOptions = _ref.departureDateOptions,
      departureDateEnd = _ref.departureDateEnd,
      departureDateStart = _ref.departureDateStart,
      extensionOptions = _ref.extensionOptions,
      footnotes = _ref.footnotes,
      hasUser = _ref.hasUser,
      isProductWithSetDates = _ref.isProductWithSetDates,
      isSummerCamp = _ref.isSummerCamp,
      kidsOptions = _ref.kidsOptions,
      newsletter = _ref.newsletter,
      consentOptins = _ref.consentOptins,
      redirectUris = _ref.redirectUris,
      product = _ref.product,
      quotation = _ref.quotation;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var router = Object(next_router["useRouter"])();
  var initialFormData = Object(es["e" /* useSelector */])(function (state) {
    var userInfo = state.userInfo;
    return getFormUser(userInfo);
  });
  return ProductQuotationFormContainer_jsx(formik_esm["d" /* Formik */], {
    initialStatus: {
      state: FORM_STATUS.NEW
    },
    initialValues: productQuotationForm_utils_getInitialFormValues({
      departureCityDisabled: departureCityDisabled,
      extensionOptions: extensionOptions,
      isProductWithSetDates: isProductWithSetDates,
      isSummerCamp: isSummerCamp,
      traveler: initialFormData
    }),
    initialTouched: hasUser ? {
      traveler: {
        civility: true,
        firstName: true,
        lastName: true,
        email: true,
        phone: true,
        gmNumber: true
      }
    } : {},
    validateOnMount: true,
    validationSchema: productQuotationForm_utils_getFormSchema(i18n["h" /* t */], {
      agencies: agencies,
      civilityOptions: civilityOptions,
      departureCityOptions: departureCityOptions,
      departureDateOptions: departureDateOptions,
      extensionOptions: extensionOptions,
      isProductWithSetDates: isProductWithSetDates,
      isSummerCamp: isSummerCamp,
      locale: appContext.locale
    }),
    onSubmit: /*#__PURE__*/function () {
      var _ref2 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(values, actions) {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return handleSubmit(values, {
                  actions: actions,
                  appContext: appContext,
                  isSummerCamp: isSummerCamp,
                  newsletter: newsletter,
                  router: router,
                  product: product,
                  quotation: quotation,
                  redirectUris: redirectUris
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref2.apply(this, arguments);
      };
    }()
  }, ProductQuotationFormContainer_jsx(ProductQuotationForm, {
    adultsOptions: adultsOptions,
    ageIndicationAdults: ageIndicationAdults,
    ageIndicationKids: ageIndicationKids,
    agencies: agencies,
    availableDatesIndication: availableDatesIndication,
    civilityOptions: civilityOptions,
    dateFormat: dateFormat,
    departureCityDisabled: departureCityDisabled,
    departureCityOptions: departureCityOptions,
    departureDateOptions: departureDateOptions,
    departureDateEnd: departureDateEnd,
    departureDateStart: departureDateStart,
    extensionOptions: extensionOptions,
    footnotes: footnotes,
    hasUser: hasUser,
    isProductWithSetDates: isProductWithSetDates,
    isSummerCamp: isSummerCamp,
    kidsOptions: kidsOptions,
    newsletter: newsletter,
    consentOptins: consentOptins,
    product: product
  }));
}
// EXTERNAL MODULE: ./src/client/components/widgets/prebooking-form/CustomerLogin.jsx
var CustomerLogin = __webpack_require__("ZQ8D");

// CONCATENATED MODULE: ./src/client/components/lines/product-quotation-form-line/ProductQuotationFormLine.jsx






var ProductQuotationFormLine_jsx = react_default.a.createElement;













var PRODUCT_TYPES = dist["constants"].PRODUCT_TYPES;
var PRODUCT_TYPES_WITH_SET_DATES = [PRODUCT_TYPES.CRUISE, PRODUCT_TYPES.SUMMER_CAMP, PRODUCT_TYPES.TOUR];
var SUMMER_CAMP_AVAILABLE_DATES = [{
  value: '20220702'
}, {
  value: '20220709'
}, {
  value: '20220716'
}];
var ProductQuotationFormLine_ProductQuotationFormLine = function ProductQuotationFormLine(props) {
  var _config$account, _config$account$authe, _stopover$extension;

  var bookingCriteria = props.bookingCriteria,
      civilities = props.civilities,
      coordinates = props.coordinates,
      config = props.config,
      criteria = props.criteria,
      legalInformations = props.legalInformations,
      login = props.login,
      newsletter = props.newsletter,
      pax = props.pax,
      product = props.product,
      quotation = props.quotation,
      specialRequest = props.specialRequest,
      stopover = props.stopover,
      success = props.success,
      title = props.title,
      tour = props.tour,
      travelAgencies = props.travelAgencies;
  Object(i18n["a" /* addTranslationKeys */])({
    productQuotationForm: {
      coordinates: coordinates,
      criteria: criteria,
      pax: pax,
      quotation: quotation,
      login: login,
      specialRequest: specialRequest,
      title: title
    }
  });

  var _useAppContext = Object(ReactAppContext["c" /* useAppContext */])(),
      hasUser = _useAppContext.isUserLogged,
      locale = _useAppContext.locale;

  var hasLoginButton = !!(config === null || config === void 0 ? void 0 : (_config$account = config.account) === null || _config$account === void 0 ? void 0 : (_config$account$authe = _config$account.authenticated) === null || _config$account$authe === void 0 ? void 0 : _config$account$authe.greeting);
  var productType = product.type;
  var noExtension = criteria.noExtension,
      noTransportation = criteria.noTransportation,
      transportationDisabled = criteria.transportationDisabled;
  var isEscapade = product.rangeId === productQuotationForm_constants["j" /* RANGE_ESCAPADE */];
  var isSummerCamp = productType === PRODUCT_TYPES.SUMMER_CAMP;
  var isProductWithSetDates = PRODUCT_TYPES_WITH_SET_DATES.includes(productType) && !isEscapade;
  var extensionName = (stopover === null || stopover === void 0 ? void 0 : (_stopover$extension = stopover.extension) === null || _stopover$extension === void 0 ? void 0 : _stopover$extension.title) || '';
  var extensionOptions = []; // The API returns an empty string when no extension is available

  if (extensionName.length > 0) {
    extensionOptions.push({
      name: noExtension,
      value: productQuotationForm_constants["g" /* NO_VALUE */]
    }, {
      name: extensionName,
      value: extensionName
    });
  }

  var departureCityOptions = bookingCriteria.departureCities;

  if (transportationDisabled) {
    departureCityOptions = [{
      name: noTransportation,
      value: productQuotationForm_constants["g" /* NO_VALUE */]
    }];
  } else if (departureCityOptions.length === 1 && departureCityOptions[0].value === productQuotationForm_constants["g" /* NO_VALUE */] && !isSummerCamp) {
    // The API returns this array when no transport is available:
    // [{value : "NO", name : "No Transport"}]
    departureCityOptions = [];
  }

  var availableDatesIndication = pax.noMoreAvailableDates;
  var ageIndicationAdults = isSummerCamp ? pax.kidsAgeIndicationSummerCamp : pax.adultAgeIndication;
  var ageIndicationKids = isEscapade ? pax.kidsAgeIndicationEscapade : pax.kidsAgeIndicationTour;
  var today = new Date();
  var futureDate = new Date(today);
  futureDate.setDate(futureDate.getDate() + 1);
  var departureDateStart = new Date(criteria.departureDateStart);
  departureDateStart = moment_default()(departureDateStart).isBefore(moment_default()(today)) ? futureDate : departureDateStart;
  var departureDateEnd = new Date(criteria.departureDateEnd);
  var adultsOptions = isSummerCamp ? Object(selectOptionsBuilders["b" /* getChildrenOptions */])(pax.teensChoices, productQuotationForm_constants["f" /* MIN_FORM_TEENS */], productQuotationForm_constants["c" /* MAX_FORM_TEENS */]).map(function (_ref) {
    var label = _ref.label,
        value = _ref.value;
    return {
      name: label,
      value: value.toString()
    };
  }) : Object(selectOptionsBuilders["a" /* getAdultsOptions */])(pax.adultsChoices, productQuotationForm_constants["d" /* MIN_FORM_ADULTS */], productQuotationForm_constants["a" /* MAX_FORM_ADULTS */]).map(function (_ref2) {
    var label = _ref2.label,
        value = _ref2.value;
    return {
      name: label,
      value: value.toString()
    };
  });
  var kidsOptions = Object(selectOptionsBuilders["b" /* getChildrenOptions */])(pax.kidsChoices, productQuotationForm_constants["e" /* MIN_FORM_KIDS */], productQuotationForm_constants["b" /* MAX_FORM_KIDS */]).map(function (_ref3) {
    var label = _ref3.label,
        value = _ref3.value;
    return {
      name: label,
      value: value.toString()
    };
  });
  var agencies = Object(PrebookingFormLine_utils["h" /* getTravelAgencyOptions */])(travelAgencies, locale);
  var consentOptins = Object(PrebookingFormLine_utils["f" /* getNewsletterOptins */])(legalInformations.consentOptins || []);
  var redirectUris = {
    success: success ? success.url : null
  };
  var loginLabels = {
    memberSpace: Object(i18n["h" /* t */])('productQuotationForm.login.memberSpace'),
    memberSpaceTitle: Object(i18n["h" /* t */])('productQuotationForm.login.memberSpaceTitle'),
    labelCTA: Object(i18n["h" /* t */])('productQuotationForm.login.labelCTA')
  };
  return ProductQuotationFormLine_jsx("div", {
    className: "relative isolate z-6 bg-white"
  }, ProductQuotationFormLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    "data-testid": productQuotationForm_constants["i" /* QUOTATION_FORM_SECTION_ID */],
    id: productQuotationForm_constants["i" /* QUOTATION_FORM_SECTION_ID */]
  }, ProductQuotationFormLine_jsx("div", {
    className: "PriceTicket-sticky-beacon"
  }), ProductQuotationFormLine_jsx(Title["a" /* Title */], {
    className: "mb-20 mt-30 px-10",
    hLevel: 2,
    theme: "title-sans-n4"
  }, Object(i18n["h" /* t */])('productQuotationForm.title')), (!login || login.displayLoginIcon) && ProductQuotationFormLine_jsx(CustomerLogin["a" /* CustomerLogin */], {
    hasLoginButton: hasLoginButton,
    hasUser: hasUser,
    labels: loginLabels
  }), ProductQuotationFormLine_jsx(ProductQuotationFormContainer, {
    adultsOptions: adultsOptions,
    ageIndicationAdults: ageIndicationAdults,
    ageIndicationKids: ageIndicationKids,
    agencies: agencies,
    availableDatesIndication: availableDatesIndication,
    civilityOptions: (civilities === null || civilities === void 0 ? void 0 : civilities.adult) || [],
    dateFormat: criteria.dateFormat,
    departureCityDisabled: transportationDisabled,
    departureCityOptions: departureCityOptions,
    departureDateEnd: departureDateEnd,
    departureDateOptions: // TODO: this is done for ODR purpose to do remove this when
    // the summer camp date are set
    isSummerCamp ? SUMMER_CAMP_AVAILABLE_DATES.map(function (_ref4) {
      var value = _ref4.value;
      return {
        name: Object(apiDate["j" /* momentFromApiDate */])(value).format(criteria.dateFormat),
        value: value
      };
    }) : tour.availableDates.map(function (_ref5) {
      var name = _ref5.name,
          value = _ref5.value;
      return {
        name: name,
        value: value.toString()
      };
    }),
    departureDateStart: departureDateStart,
    extensionOptions: extensionOptions,
    footnotes: quotation.indication,
    hasUser: hasUser,
    isProductWithSetDates: isProductWithSetDates,
    isSummerCamp: isSummerCamp,
    kidsOptions: kidsOptions,
    newsletter: newsletter,
    consentOptins: consentOptins,
    product: product,
    redirectUris: redirectUris,
    quotation: {
      error: quotation.error
    }
  })));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/product-quotation-form/descriptor.js

/* harmony default export */ var descriptor = __webpack_exports__["default"] = (ProductQuotationFormLine_ProductQuotationFormLine);

/***/ })

}]);